import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {PLAPP, plAppConfig } from '../config/plAppConfig';
import { getAppUrlInfo } from '../utils/urls';
import { useLocation } from 'react-router-dom';
 
const menuStyle: React.CSSProperties = {
  gridTemplateColumns: 'repeat(3, 1fr)',
};

const iconStyle: React.CSSProperties = {
  marginBottom: 8,
};

const AppMenu = () => {
  const { isLocalhost } = getAppUrlInfo();
  const location = useLocation();
  
  // Determine selected app based on URL context
  const getSelectedApp = () => {
    if (location.pathname.includes('/finance')) {
      return 'finance';
    }
    if (location.pathname.includes('/master-data')) {
      return 'masters';
    }
    if (location.pathname.includes('/leads')) {
      return 'leads';
    }
    if (location.pathname.includes('/accounts')) {
      return 'accounts';
    }
    // Default to accounts if no specific context
    return 'accounts';
  };
  
  const selectedApp = getSelectedApp();
  
  // Generate app URLs with dashboard paths
  const getAppUrl = ({ key, port }: PLAPP) => {
    const baseUrl = isLocalhost ? `http://localhost:3000` : `https://accounts.parkinglap.com`;
    
    // For apps with dashboards, append the dashboard path
    switch (key) {
      case 'accounts':
        return `${baseUrl}/accounts`;
      case 'finance':
        return `${baseUrl}/finance`;
      case 'masters':
        return `${baseUrl}/master-data`;
      case 'leads':
        return `${baseUrl}/leads`;
      default:
        // For other apps without dashboards, use base URL
        return baseUrl;
    }
  };
  
  return (
    <div
      className="bg-white p-4 rounded-xl shadow-xl grid gap-5 min-w-[240px]"
      style={menuStyle}
    >
      {plAppConfig.map((app) => {
        const isSelected = app.key === selectedApp;

        const content = (
          <div
            className={`flex flex-col items-center p-2 rounded-md transition ${isSelected
              ? 'bg-gray-200 cursor-default'
              : 'hover:bg-gray-100 cursor-pointer'
              }`}
          >
            <FontAwesomeIcon
              icon={app.icon}
              size="2x"
              style={{ ...iconStyle, color: app.color }}
            />
            <span className="text-sm text-center mt-1">{app.name}</span>
          </div>
        );

        return (
          <div key={app.key}> {isSelected ? (content) : (<a href={getAppUrl(app)} /* target="_blank" */ > {content} </a>)} </div>
        );
      })}
    </div>
  );
};

export default AppMenu;
